module.exports = __webpack_public_path__ + "img/MintPoolredeemShow_img.9043d1bc.png";